function stableKeysOrderReplacer(_key: unknown, value: unknown): unknown {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const keys = Object.keys(value).sort();
    const length = keys.length;
    const result: {[key: string]: unknown} = {};

    for (let i = 0; i < length; i++) {
      result[keys[i]] = (value as {[key: string]: unknown})[keys[i]];
    }

    return result;
  }

  // JSON.stringify removes undefined values as they are invalid JSON props, so we need to replace them with null
  return value === undefined ? null : value;
}

/**
 * Prefer {@link stableStringify} unless you explicitly need undefined preserved as JSON `null`.
 *
 * This export is marked UNSAFE because the replacer turns `undefined` into `null`, unlike
 * `stableStringify`, which leaves values as-is for the default `JSON.stringify` behavior (where
 * `undefined` in objects is omitted and in arrays becomes `null`). Call sites that assume the same
 * semantics as `stableStringify` can get subtle bugs from the extra null coercions.
 */
// eslint-disable-next-line camelcase
export default function UNSAFE_stableStringify(value: unknown): string {
  return JSON.stringify(value, stableKeysOrderReplacer);
}
